import { FC, useMemo } from "react";
import { SEND_PROJECT_TABS } from "../SendProjectModal";
import { NoProjectPrompt } from "../NoProjectPrompt";
import { Competition, Nullable, Project } from "@brg/api";
import { ProjectsGridNew } from "shared/components/grids";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import { RingPositions } from "shared/constants/ringPositionType";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ProjectDelegate } from "project-delegate";

export const SendProjectsContent: FC<{ 
    projects: any[],
    selectedProjects: any[], 
    activeTab: SEND_PROJECT_TABS, 
    noProjectsVisible: boolean,
    competition: Competition,
    loading: boolean,
    onSelect: (id: string) => void,
    isAlreadyProject: (id: string) => boolean,
    legalContestFormAfterPublish?: boolean,
    isAttemptsLimitReached?: boolean,
}> = ({ 
    projects, 
    selectedProjects,
    activeTab, 
    noProjectsVisible, 
    competition,
    loading,
    onSelect,
    isAlreadyProject,
    legalContestFormAfterPublish,
    isAttemptsLimitReached,
}) => {

    const computeProjects = useMemo(() => {
        if (activeTab === SEND_PROJECT_TABS.approved) {
            return projects?.filter((project) => isAlreadyProject(project?.projectId ?? '') )
        }

        return projects
    } , [activeTab, projects])

    if (noProjectsVisible) {
        return (
            <NoProjectPrompt
                competition={competition}
                visibility={noProjectsVisible}
                legalContestFormAfterPublish={legalContestFormAfterPublish}
                isAttemptsLimitReached={isAttemptsLimitReached}
            />
        )
    }

    return (
                    <ProjectsGridNew k={undefined} isLoading={loading}>
                      {computeProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                        return (
                          // @ts-ignore
                          <ProjectCardNew
                            project={v as any}
                            isModal={false}
                            withoutGoToProject={true}
                            onProjectClick={(projectId?: string, e?: any) => {
                              e?.stopPropagation();
                              e?.preventDefault();
                              onSelect(projectId ?? '');
                            }}
                            isSelectable={activeTab !== SEND_PROJECT_TABS.approved}
                            //@ts-ignore
                            isRejected={ProjectDelegate.isRejectedProject(v)}
                            key={(v?.projectId || '') + index}
                            {...computeProject(v)}
                            // isSelectRightNeed={isMobile}
                            metaAlwaysVisible={activeTab !== SEND_PROJECT_TABS.approved}
                            
                            selectRingPosition={RingPositions.right}
                            onSelect={(projectId: string) => {
                                if (activeTab === SEND_PROJECT_TABS.approved) return;
                                onSelect(projectId);
                            }}
                            selected={selectedProjects?.includes(v?.projectId ?? '') && activeTab !== SEND_PROJECT_TABS.approved}
                            alreadyProject={isAlreadyProject(v?.projectId ?? '') && activeTab !== SEND_PROJECT_TABS.approved}
                          />
                        );
        
                      })}
                    </ProjectsGridNew>
    )

}import { FC, useMemo } from "react";
import { SEND_PROJECT_TABS } from "../SendProjectModal";
import { NoProjectPrompt } from "../NoProjectPrompt";
import { Competition, Nullable, Project } from "@brg/api";
import { ProjectsGridNew } from "shared/components/grids";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import { RingPositions } from "shared/constants/ringPositionType";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ProjectDelegate } from "project-delegate";

export const SendProjectsContent: FC<{ 
    projects: any[],
    selectedProjects: any[], 
    activeTab: SEND_PROJECT_TABS, 
    noProjectsVisible: boolean,
    competition: Competition,
    loading: boolean,
    onSelect: (id: string) => void,
    isAlreadyProject: (id: string) => boolean,
    legalContestFormAfterPublish?: boolean,
    isAttemptsLimitReached?: boolean,
}> = ({ 
    projects, 
    selectedProjects,
    activeTab, 
    noProjectsVisible, 
    competition,
    loading,
    onSelect,
    isAlreadyProject,
    legalContestFormAfterPublish,
    isAttemptsLimitReached,
}) => {

    const computeProjects = useMemo(() => {
        if (activeTab === SEND_PROJECT_TABS.approved) {
            return projects?.filter((project) => isAlreadyProject(project?.projectId ?? '') )
        }

        return projects
    } , [activeTab, projects])

    if (noProjectsVisible) {
        return (
            <NoProjectPrompt
                competition={competition}
                visibility={noProjectsVisible}
                legalContestFormAfterPublish={legalContestFormAfterPublish}
                isAttemptsLimitReached={isAttemptsLimitReached}
            />
        )
    }

    return (
                    <ProjectsGridNew k={undefined} isLoading={loading}>
                      {computeProjects?.map((v: Nullable<Partial<Project<'Local'>>>, index: number) => {
                        return (
                          // @ts-ignore
                          <ProjectCardNew
                            project={v as any}
                            isModal={false}
                            withoutGoToProject={true}
                            onProjectClick={(projectId?: string, e?: any) => {
                              e?.stopPropagation();
                              e?.preventDefault();
                              onSelect(projectId ?? '');
                            }}
                            isSelectable={activeTab !== SEND_PROJECT_TABS.approved}
                            //@ts-ignore
                            isRejected={ProjectDelegate.isRejectedProject(v)}
                            key={(v?.projectId || '') + index}
                            {...computeProject(v)}
                            // isSelectRightNeed={isMobile}
                            metaAlwaysVisible={activeTab !== SEND_PROJECT_TABS.approved}
                            
                            selectRingPosition={RingPositions.right}
                            onSelect={(projectId: string) => {
                                if (activeTab === SEND_PROJECT_TABS.approved) return;
                                onSelect(projectId);
                            }}
                            selected={selectedProjects?.includes(v?.projectId ?? '') && activeTab !== SEND_PROJECT_TABS.approved}
                            alreadyProject={isAlreadyProject(v?.projectId ?? '') && activeTab !== SEND_PROJECT_TABS.approved}
                          />
                        );
        
                      })}
                    </ProjectsGridNew>
    )

}